/**
 * Turns array values into an object
 * for easy lookups
 */

import is_array from 'is-array'

export default function not_in (arr) {
  if (!is_array(arr)) arr = []
  var lookup = arr.reduce((p, v) => {
    p[v] = true
    return p
  }, {})
  return (t) => !lookup[t]
}
